import useLinkRelValue from "./useLinkRelValue";

export default useLinkRelValue;
